import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';


class NotFound extends Component {
  render() {
    return (
      <div className="page-not-found">
        <center>
          <br/>
          <br/>
          <br/>
        <h1>404 - Nothing here!</h1>
        <Link to="/">&larr; go back</Link>
        </center>
          <br/>
          <br/>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound.jsx